import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Dashboard from "./components/dashboard";
import Login from "./home/login";
import { rootPath } from "./utils/varialbles";
// import { w3cwebsocket as W3CWebSocket } from "websocket";
// // import Loading from "./components/loading";
// let socketConnection = new W3CWebSocket('ws://localhost:8000/ws/download_records/');
// console.log(socketConnection, 'socketConnection');
function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path={rootPath} component={Dashboard} />
          <Route path="/" exact component={Login} />
          {/* <Route path="/loader" component={Loading} /> */}
        </Switch>
      </Router>
    </div>
  );
}

export default App;
